import React from "react";
import { Box, Card, CardContent, Typography, Grid, LinearProgress } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import {
  SiSpringboot,
  SiReact,
  SiMysql,
  SiBitbucket,
  SiAwsamplify,
} from "react-icons/si";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const SkillCard = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 300,
  margin: theme.spacing(2),
  animation: `${fadeIn} 1s ease-in-out`,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const skills = [
  {
    name: "React",
    icon: <SiReact size={40} color="#61DAFB" />,
    description: "Biblioteca para construir interfaces de usuario.",
    level: 40,
    category: "Frontend",
  },
  {
    name: "Spring Boot",
    icon: <SiSpringboot size={40} color="#6DB33F" />,
    description: "Framework Java para crear aplicaciones backend.",
    level: 40,
    category: "Backend",
  },
  {
    name: "MySQL",
    icon: <SiMysql size={40} color="#4479A1" />,
    description: "Sistema de gestión de bases de datos relacional.",
    level: 60,
    category: "Herramientas y Servicios",
  },
  {
    name: "Bitbucket",
    icon: <SiBitbucket size={40} color="#0052CC" />,
    description: "Plataforma de gestión de código fuente.",
    level: 75,
    category: "Herramientas y Servicios",
  },
  {
    name: "AWS",
    icon: <SiAwsamplify size={40} color="#FF9900" />,
    description: "Servicios de AWS para desplegar aplicaciones.",
    level: 65,
    category: "Herramientas y Servicios",
  },
];

const SkillsComponent = () => {
  return (
    <Box
      sx={{
        padding: 3,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "background.default", // Usa el color de fondo del tema
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1200,
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "background.paper", // Usa el color de fondo del tema
          borderRadius: "8px",
          boxShadow: 3,
        }}
      >
        <Typography variant="h4" gutterBottom align="center">
          Mis Habilidades
        </Typography>

        {["Frontend", "Backend", "Herramientas y Servicios"].map((category) => (
          <React.Fragment key={category}>
            <Typography variant="h6" color="primary" gutterBottom sx={{ marginTop: 5 }}>
              {category}
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              {skills
                .filter((skill) => skill.category === category)
                .map((skill, index) => (
                  <Grid item key={index}>
                    <SkillCard>
                      <CardContent>
                        <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
                          {skill.icon}
                        </Box>
                        <Typography gutterBottom variant="h5" component="div">
                          {skill.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {skill.description}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={skill.level}
                          sx={{ marginTop: 2, width: "100%" }}
                        />
                      </CardContent>
                    </SkillCard>
                  </Grid>
                ))}
            </Grid>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default SkillsComponent;
